import { PowerBankActionTypes } from "./constants";

export interface PowerBankActionType {
  type:
    | PowerBankActionTypes.API_RESPONSE_SUCCESS
    | PowerBankActionTypes.API_RESPONSE_ERROR
    | PowerBankActionTypes.GET_POWERBANKS
    | PowerBankActionTypes.ADD_POWERBANKS
    | PowerBankActionTypes.UPDATE_POWERBANKS
    | PowerBankActionTypes.DELETE_POWERBANKS;

  payload: any;
}

// Common success
export const PowerBankApiResponseSuccess = (actionType: string, data: any): PowerBankActionType => ({
  type: PowerBankActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Common error
export const PowerBankApiResponseError = (actionType: string, error: string): PowerBankActionType => ({
  type: PowerBankActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// Get power banks
export const getPowerBanks = (status?: string, keyword?: string): PowerBankActionType => ({
  type: PowerBankActionTypes.GET_POWERBANKS,
  payload: { status, keyword },
});

// Add power bank
export const addPowerBank = (
  box_id: number | string,
  unique_id: string,
  status: string,
  battery_level: number,
  health_status: string,
  slot_number: number | string
): PowerBankActionType => ({
  type: PowerBankActionTypes.ADD_POWERBANKS,
  payload: {
    box_id,
    unique_id,
    status,
    battery_level,
    health_status,
    slot_number,
  },
});

// Update power bank
export const updatePowerBank = (
  id: string | number,
  box_id: number | string,
  unique_id: string,
  status: string,
  battery_level: number,
  health_status: string,
  slot_number: number | string
): PowerBankActionType => ({
  type: PowerBankActionTypes.UPDATE_POWERBANKS,
  payload: { id, box_id, unique_id, status, battery_level, health_status, slot_number },
});

// Delete power bank
export const deletePowerBank = (id: string): PowerBankActionType => ({
  type: PowerBankActionTypes.DELETE_POWERBANKS,
  payload: { id },
});
